import { createAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { DepartmentsQueryI } from '@modules/App/interfaces/DepartmentsQueryI';

export const loadAllDepartments = createAction<DepartmentsQueryI>(`${SLICE_NAME}/loadAllDepartments`);
export const loadHiddenDepartments = createAction(`${SLICE_NAME}/loadHiddenDepartments`);
